/**
 * @type {{index: number, label: string, key: string}[]}
 */

export const LANGUAGE_OPTIONS = [
  { index: 0, label: 'locale_english', key: 'en' },
  { index: 1, label: 'locale_italy', key: 'it' },
  { index: 2, label: 'locale_spain', key: 'es' },
  { index: 3, label: 'locale_german', key: 'de' },
  { index: 4, label: 'locale_french', key: 'fr' },
  { index: 5, label: 'locale_polish', key: 'pl' },
  { index: 6, label: 'locale_netherlands', key: 'nl' },
  { index: 7, label: 'locale_bulgarian', key: 'bg' },
  { index: 8, label: 'locale_czech', key: 'cs' },
  { index: 9, label: 'locale_danish', key: 'da' },
  { index: 10, label: 'locale_finnish', key: 'fi' },
  { index: 11, label: 'locale_hungarian', key: 'hu' },
  { index: 12, label: 'locale_portuguese', key: 'pt' },
  { index: 13, label: 'locale_estonian', key: 'et' },
  { index: 14, label: 'locale_croatian', key: 'hr' },
  { index: 15, label: 'locale_greek', key: 'el' },
  { index: 16, label: 'locale_norwegian', key: 'no' },
  { index: 17, label: 'locale_latvian', key: 'lv' },
  { index: 18, label: 'locale_lithuanian', key: 'lt' },
  { index: 19, label: 'locale_romanian', key: 'ro' },
  { index: 20, label: 'locale_russian', key: 'ru' },
  { index: 21, label: 'locale_swedish', key: 'sv' },
  { index: 22, label: 'locale_slovenian', key: 'sl' },
  { index: 23, label: 'locale_slovak', key: 'sk' },
  { index: 24, label: 'locale_serbian', key: 'sr' },
  { index: 25, label: 'locale_turkish', key: 'tr' },
  { index: 26, label: 'locale_ukrainian', key: 'uk' },
  { index: 27, label: 'locale_korean', key: 'ko' },
  { index: 28, label: 'locale_traditional_chinese', key: 'zh_TW' },
  { index: 29, label: 'locale_thai', key: 'th' },
  { index: 30, label: 'locale_vietnamese', key: 'vi' },
  { index: 31, label: 'locale_japanese', key: 'ja' },
  { index: 32, label: 'locale_Hebrew', key: 'he' },
  { index: 33, label: 'locale_portuguese_brazil', key: 'pt_BR' },
  { index: 34, label: 'locale_arabic', key: 'ar' },
  { index: 35, label: 'locale_farsi', key: 'fa' },
  { index: 36, label: 'locale_indonesian', key: 'in' },
  { index: 37, label: 'locale_uzbek', key: 'uz' },
  { index: 38, label: 'locale_kazakh', key: 'kk' },
  { index: 39, label: 'locale_cambodian', key: 'kh' },
  { index: 40, label: 'locale_kurdish', key: 'ku' },
  { index: 41, label: 'locale_pakistani', key: 'ur' },
  { index: 42, label: 'locale_Bengali', key: 'bn' },
  { index: 43, label: 'locale_Azerbaijan', key: 'az' }
];

/**
 * @type {{[index: number]: string; [key: string]: number}}
 */
export const INDEX_TO_KEY = LANGUAGE_OPTIONS.reduce((obj, item) => {
  obj[item.index] = item.key;
  obj[item.key] = item.index;
  return obj;
}, {});

export const BROWSER_LANGUAGE_MAP = {
  'zh-CN': 'en',
  'zh-SG': 'en',
  'zh-TW': 'zh_TW',
  'zh-HK': 'zh_TW',
  en: 'en',
  'en-US': 'en',
  'en-EG': 'en',
  'en-AU': 'en',
  'en-GB': 'en',
  'en-CA': 'en',
  'en-NZ': 'en',
  'en-IE': 'en',
  'en-ZA': 'en',
  'en-JM': 'en',
  'en-BZ': 'en',
  'en-TT': 'en',
  it: 'it',
  'it-CH': 'it',
  ru: 'ru',
  'ru-MI': 'ru',
  'ru-mo': 'ru',
  th: 'th',
  vi: 'vi',
  ja: 'ja',
  'ja-JP': 'ja',
  ko: 'ko',
  'ko-kr': 'ko',
  de: 'de',
  'de-CH': 'de',
  'de-AT': 'de',
  'de-LU': 'de',
  'de-LI': 'de',
  fr: 'fr',
  'fr-BE': 'fr',
  'fr-CA': 'fr',
  'fr-CH': 'fr',
  'fr-LU': 'fr',
  es: 'es',
  'es-AR': 'es',
  'es-GT': 'es',
  'es-CR': 'es',
  'es-PA': 'es',
  'es-DO': 'es',
  'es-MX': 'es',
  'es-VE': 'es',
  'es-CO': 'es',
  'es-PE': 'es',
  'es-EC': 'es',
  'es-CL': 'es',
  'es-UY': 'es',
  'es-PY': 'es',
  'es-BO': 'es',
  'es-SV': 'es',
  'es-HN': 'es',
  'es-NI': 'es',
  'es-PR': 'es',
  'ar-SA': 'ar',
  'ar-IQ': 'ar',
  'ar-EG': 'ar',
  'ar-LY': 'ar',
  'ar-DZ': 'ar',
  'ar-MA': 'ar',
  'ar-TN': 'ar',
  'ar-OM': 'ar',
  'ar-YE': 'ar',
  'ar-SY': 'ar',
  'ar-JO': 'ar',
  'ar-LB': 'ar',
  'ar-KW': 'ar',
  'ar-AE': 'ar',
  'ar-BH': 'ar',
  'ar-QA': 'ar',
  pt: 'pt',
  pt_PT: 'pt',
  pt_PT_EURO: 'pt',
  'pt-BR': 'pt_BR',
  ro: 'ro',
  'ro-MO': 'ro',
  af: 'en',
  sq: 'en',
  'sq-AL': 'en',
  eu: 'en',
  bg: 'bg',
  be: 'en',
  ca: 'en',
  hr: 'hr',
  cs: 'cs',
  da: 'da',
  nl: 'nl',
  nl_NL: 'nl',
  'nl-BE': 'nl',
  et: 'et',
  fo: 'en',
  fa: 'fa',
  fi: 'fi',
  gd: 'en',
  el: 'el',
  he: 'he',
  hi: 'en',
  hu: 'hu',
  is: 'en',
  is_IS: 'en',
  id: 'in',
  lv: 'lv',
  lt: 'lt',
  mk: 'en',
  mt: 'en',
  no: 'no',
  no_NO: 'no',
  no_NO_NY: 'no',
  pl: 'pl',
  rm: 'en',
  sz: 'en',
  sr: 'sr',
  sk: 'sk',
  sl: 'sl',
  sb: 'en',
  sx: 'en',
  sv: 'sv',
  'sv-FI': 'sv',
  ts: 'en',
  tn: 'en',
  tr: 'tr',
  uk: 'uk',
  ur: 'ur',
  ve: 'en',
  xh: 'en',
  ji: 'en',
  zu: 'en',
  bn: 'bn',
  az: 'az'
};
